// List of all weather stations
import Leaflet from 'leaflet';

//#region temperature icon maker and corresponding color function
export function gustMarker(gust: string): Leaflet.DivIcon {
    var gustFloat:number = parseFloat(gust);
    var markerHtmlStyles = `background-color: ${setColorOfGustBlock(gustFloat)}; 
                        margin: 0px; 
                        color: ${setColorOfGustText(gustFloat)};`;

    return Leaflet.divIcon({
      className: 'number-icon',
      html: `<div style="${markerHtmlStyles}">${gust}</div>`,
      iconSize: setGustIconSize(gust)
    });
};

function setColorOfGustText(gust: number): string {
    if (gust >= 184.0 && gust < 220.0)
    {
      return "black";
    }
    
    return "white";
}

function setColorOfGustBlock(gust: number): string {
  switch (true) {
    case (gust >= 220.0):
      return "#FF00FF";
    case (gust >= 184.0):
      return "#ff7800";
    case (gust >= 150.0):
      return "#cf7572ff";
    case (gust >= 118.0):
      return "red";
    case (gust >= 88.0):
      return "blue";
    case (gust >= 63.0):
      return "green";
    case (gust >= 41.0):
      return "black";
    default:
      return "gray"; //gray
  }
}

function setGustIconSize(gustStr: string): Leaflet.PointExpression {
    switch (gustStr?.length) {
      case 1:
        return [23, 25];
      case 2:
        return [26, 25];
      case 3:
        return [30, 25];
      default:
        return [35, 25];
    }
}
//#endregion